import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class PassportInOutPrintReport extends Component {
  render() {

    const { transactions, total } = this.props;
    return (
      <Table celled fixed singleLine>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="7" style={{ textAlign:"center" }}>Passport In/Out Report</Table.HeaderCell>
        </Table.Row>

          <Table.Row>
            <Table.HeaderCell width={1} style={{ textAlign: 'center' }}>Sr</Table.HeaderCell>
            <Table.HeaderCell width={3}>Name</Table.HeaderCell>
            <Table.HeaderCell width={2}>Mobile</Table.HeaderCell>
            <Table.HeaderCell width={2}>Passport</Table.HeaderCell>
            <Table.HeaderCell width={2} style={{ textAlign: 'center' }}>In</Table.HeaderCell>
            <Table.HeaderCell width={2} style={{ textAlign: 'center' }}>Out</Table.HeaderCell>
            <Table.HeaderCell width={3} style={{ textAlign: 'center' }}>In/Out Expiry Date</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map(transaction => (
            <Table.Row>
              <Table.Cell style={{ textAlign: 'center' }}>{transaction.sr}</Table.Cell>
              <Table.Cell>{transaction.name}</Table.Cell>
              <Table.Cell>{transaction.mobile}</Table.Cell>
              <Table.Cell>{transaction.passport}</Table.Cell>
              <Table.Cell style={{ textAlign: 'center',color: 'green' }}>
                {transaction.in_out_status == 1 ? "Yes" : ""}
              </Table.Cell>
              <Table.Cell style={{ textAlign: 'center',color: 'red' }}>
                {transaction.in_out_status == 2 ? "Yes" : ""}
              </Table.Cell>
              <Table.Cell style={{ textAlign: 'center' }}>{transaction.in_out_date != "01/01/1970" ? transaction.in_out_date : ""}</Table.Cell>
            </Table.Row>
          )
          )}

          {/* <Table.Row>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell colspan="3" style={{ textAlign:"left",fontSize:'15px' }}><b>{total}</b></Table.Cell>
             
            </Table.Row> */}

        </Table.Body>
      </Table>
    );
  }
}
export default PassportInOutPrintReport;
